/* Bright Day optional protection: one visible line per order; removal is remembered. */
(() => {
  if (window.bdShippingProtectionLoaded) return;
  window.bdShippingProtectionLoaded = true;
  const variant = 69055142985762;
  const root = window.Shopify?.routes?.root || '/';
  const attr = '_brightday_protection_opt_out';
  let running = false, pending = false, removed = false, previous = null, choice = null;
  const isProtection = item => Number(item.variant_id) === variant;
  async function request(path, data) {
    const response = await fetch(root + path, data ? {
      method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data)
    } : {cache:'no-store'});
    if (!response.ok) throw new Error('Shipping protection request failed');
    return response.json();
  }
  function refresh(cart) {
    if (window.location.pathname === root + "cart" || window.location.pathname === root + "cart/") { window.location.reload(); return; }
    window.upcartRefreshCart?.();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined')
      publish(PUB_SUB_EVENTS.cartUpdate, {source:'brightday-protection', cartData:cart});
  }
  async function sync(strict = false) {
    if (running) { pending = true; return; }
    running = true;
    try {
      let cart = await request('cart.js');
      let changed = false;
      if (typeof choice === 'boolean') {
        const enabled = choice;
        choice = null;
        const updates = enabled ? {} : Object.fromEntries(cart.items.filter(isProtection).map(item => [item.key, 0]));
        cart = await request('cart/update.js', {updates, attributes:{[attr]:enabled ? 'no' : 'yes'}});
        removed = !enabled;
        previous = null;
        changed = true;
      }
      const lines = cart.items.filter(isProtection);
      const physical = cart.items.some(item => item.requires_shipping && !isProtection(item));
      if (previous === true && !lines.length && physical) removed = true;
      if (removed && physical && cart.attributes[attr] !== 'yes') {
        await request('cart/update.js', {attributes:{[attr]:'yes'}});
        cart.attributes[attr] = 'yes';
      }
      if (!physical) {
        const updates = Object.fromEntries(lines.filter(item => item.properties?._brightday_protection === 'optional').map(item => [item.key,0]));
        if (Object.keys(updates).length || cart.attributes[attr]) {
          await request('cart/update.js', {updates, attributes:{[attr]:''}}); changed = true;
        }
        removed = false;
      } else if (!lines.length && cart.attributes[attr] !== 'yes' && !removed) {
        await request('cart/add.js', {items:[{id:variant, quantity:1, properties:{_brightday_protection:'optional'}}]});
        changed = true;
      } else if (lines.length && (lines.length > 1 || lines[0].quantity !== 1)) {
        await request('cart/update.js', {updates:Object.fromEntries(lines.map((item,i)=>[item.key,i===0?1:0]))}); changed = true;
      }
      const finalCart = changed ? await request('cart.js') : cart;
      previous = finalCart.items.some(isProtection);
      if (changed) refresh(finalCart);
    } catch (error) {
      console.warn('[Bright Day] Shipping protection could not update.', error);
      if (strict === true) throw new Error('We could not confirm your shipping protection choice. Please try again.');
    }
    finally { running = false; if (pending) { pending = false; queueMicrotask(sync); } }
  }
  function onRemoved(event) {
    if (Number(event.item?.variantId) === variant && !running) removed = true;
    sync();
  }
  window.bdEnsureShippingProtection = async (enabled) => {
    const idle = async () => { while (running || pending) await new Promise(resolve => setTimeout(resolve, 25)); };
    await idle();
    if (typeof enabled === 'boolean') choice = enabled;
    await sync(true);
    await idle();
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => { if (event.source !== 'brightday-protection') sync(); });
  }
  let attempts = 0;
  const bind = () => {
    if (typeof window.upcartSubscribeCartLoaded !== 'function') return false;
    window.upcartSubscribeCartLoaded(sync);
    window.upcartSubscribeCartUpdated(sync);
    window.upcartSubscribeAddedToCart(sync);
    window.upcartSubscribeItemRemoved(onRemoved);
    return true;
  };
  if (!bind()) { const timer = setInterval(() => { if (bind() || ++attempts > 120) clearInterval(timer); }, 250); }
  sync();
})();
